import React from 'react';
import PropTypes from 'prop-types';

class Button extends React.Component {   

    constructor(props){
        super(props);
    }
    componentWillMount(){ }
    
    componentDidMount(){ }

    render(){
        return (
            <div className="Button" onClick={this.props.onClick} style={{...this.props.style, backgroundColor : this.props.color}}>
                {this.props.children}
                <style jsx>{`
                    .Button {
                        padding:5px 10px!important;
                        display: flex;
                        width:188px;
                        height: 36px;
                        color:#fff;
                        font-size:16px!important;
                        justify-content: center;
                        align-items: center;
                        border-radius:5px;
                        font-weight:700!important;
                        cursor: pointer;
                        
                    }

                    @media all and (max-width:370px){
                        .Button  {
                            width: 138px;
                        }
                    }
                `}</style>
            </div>
        )
    }
}

Button.propTypes = {
    
}

export default Button;